module.exports = __webpack_public_path__ + "img/financialReport.ac27f91a.svg";